<template lang="pug">
    div
        div(v-if="pData.installation.content" v-html='pData.installation.content')
        FileList(v-if="pData.installation.files" :files="pData.installation.files")
        VideoList(v-if="pData.installation.videos && (renderType == 'TabsScroller' || (renderType=='Panels' && activeOverlay=='install'))" :key="`${pLineKey}-videolist`" :videos="pData.installation.videos")
</template>

<script>
import FileList from './fileList'
import VideoList from './videoList'

export default {
    name: 'Installation',
    components: {
        FileList,
        VideoList,
    },
    props: {
        renderType: {
            type: String,
            default: 'TabsScroller',
            validator: (value) => {
                return value === 'Panels' || value === 'TabsScroller'
            },
        },
    },
    computed: {
        activeOverlay() {
            return this.$overlay.state.activeOverlay
        },
        pLineKey() {
            return this.$store.getters.pLineKey
        },
        pData() {
            return this.$store.state.product.data
        },
    },
    mounted() {
        if (!this.$device.isSmall && this.$route.hash) {
            // First visits and Refreshes
            window.addEventListener('load', this.scrollToHash)
            // Navigation
            this.$nextTick(() => {
                this.scrollToHash()
            })
        }
    },
    destroyed() {
        window.removeEventListener('load', this.scrollToHash)
    },
    methods: {
        scrollToHash() {
            try {
                this.$scrollTo(this.$route.hash, 500, {
                    easing: 'ease-in',
                    cancelable: false,
                    offset: -5,
                })
            } catch (e) {
                console.log('error', e)
            }
        },
    },
}
</script>
